export { rubyNative } from './native.js';
